export default __webpack_public_path__ + "static/media/focus.ac821760.svg";